









import { Component, Watch, Vue } from "vue-property-decorator";

import PageTitle from "@/components/common/PageTitle.vue";
import { personalModule, pricesModule } from "@/plugins/store-accessors";
import PriceTypes from "@/components/common/PriceTypes.vue";
import { GRD } from "@/services/consts";

@Component({
  components: {
    PriceTypes,
    PageTitle,
  },
})
export default class PricesPage extends Vue {
  get meta() {
    return pricesModule.getMeta;
  }
  get prices() {
    return pricesModule.getPrices;
  }

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  @Watch("isAuthorized")
  authGuard(state: boolean) {
    if (!state) {
      this.openModal();
    }
  }

  openModal() {
    personalModule.showLoginModal(GRD.common);
  }

  mounted() {
    this.authGuard(this.isAuthorized);
  }
}
